import { AnalyticsStore } from 'bernie-core';

interface AnalyticsPayload {
  traceId: string,
  deviceId: string,
  pageName: string,
  tealiumUtagData: any,
  adobeMappedData: {
    pageName: string,
    prop30: string,
    eVar54: string,
    eVar61: string,
    prop12: string,
    eVar18: string,
    prop10: string,
  },
  // debug: any,
  context: any,
  creationTimestamp: any,
  applicationName: string,
}

class AnalyticsUtil {
  private shouldPublishAnalyticsPayload = true;
  private shouldMarkPageUsable = true;

  public resetAnalyticsPayLoad(analytics: AnalyticsStore): void {
    analytics.resetAnalyticsForNewPage();
    this.shouldPublishAnalyticsPayload = true;
    this.shouldMarkPageUsable = false;
  }

  //This method is used when we have to do omniture logging without having analytics payload from bex-api. For example, error logging when bex-api is down or omniture logging on loading view
  public publicCustomClientSideAnalyticsPayload(
    pageId: string,
    analytics: AnalyticsStore,
    context: any,
  ): void {
    if (this.shouldPublishAnalyticsPayload) {
      const analyticsPayLoad: AnalyticsPayload = {
        traceId: context['traceInfo']['Trace-ID'],
        deviceId: context.deviceId,
        pageName: pageId,
        tealiumUtagData: {
          pageInfo: {
            pageName: pageId,
          },
        },
        adobeMappedData: {
          pageName: pageId,
          prop30: '1033',
          eVar54: 'D\u003dc30',
          eVar61: 'AFFILIATES.EXPEDIAGROUP.COM',
          prop12: context.deviceId,
          eVar18: 'D=pageName',
          prop10: context['traceInfo']['Trace-ID'],
        },
        // for debugging in the browser purpose
        // debug: {
        //   adobeMappedData: {
        //     prop12: context.deviceId,
        //     pageName: pageId,
        //     prop30: '1033',
        //     eVar54: 'D\u003dc30',
        //     eVar61: 'AFFILIATES.EXPEDIAGROUP.COM',
        //     eVar18: 'D=pageName',
        //     prop10: context['traceInfo']['Trace-ID'],
        //   },
        //   fullUisMessage: {
        //     pageIdentity: {
        //       pageIdentifier: pageId,
        //     },
        //   },
        // },
        context: {
          pageIdentity: {
            pageIdentifier: pageId,
            lineOfBusiness: 'U',
            funnelLocation: 20,
          },
        },
        creationTimestamp: new Date().getTime(),
        applicationName: 'affliate-hub',
      };
      analytics.publishClientSidePayload([analyticsPayLoad]);
      this.shouldMarkPageUsable = true;
    }
  }

  public markPageUsableIfNeeded(analyticsStore: AnalyticsStore): void {
    if (this.shouldMarkPageUsable) {
      analyticsStore.markPageUsable();
      this.shouldMarkPageUsable = false;
    }
  }

  public disableFurtherAnalyticsPayLoad(): void {
    this.shouldPublishAnalyticsPayload = false;
    this.shouldMarkPageUsable = true;
  }

  public disablePageUsable(): void {
    this.shouldMarkPageUsable = true;
  }

  public runAnalytics(
    pageId: string,
    analytics: AnalyticsStore,
    context: any,
  ) {
    analyticsUtil.resetAnalyticsPayLoad(analytics);
    analyticsUtil.publicCustomClientSideAnalyticsPayload(pageId, analytics, context);
    analyticsUtil.disableFurtherAnalyticsPayLoad();
    analyticsUtil.disablePageUsable();
  }
}

const analyticsUtil = new AnalyticsUtil();

export default analyticsUtil;
